import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Config from "../../core/config";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import ConfirmButton from "../common/ConfirmButton";
import {useNavigate} from "react-router-dom";
import Loading from "../../core/Loading";
import {UserPermission} from "../../utils/utils";
import {usePermission} from "../../core/PermissionContext";
import { showConfirm, showAlert } from '../../core/dialog';

const apiUrl = Config.apiUrl;

const SectorManager = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const newEntity = {
        id: undefined,
        name: '',
        color: '#ffffff'
    };

    const [formData, setFormData] = useState(newEntity);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    async function makeQuery() {
        if (id) {
            try {
                const url = apiUrl + '/api/sectors/id=' + id;
                setLoading(true);
                const response = await makeRequest(url, 'GET');
                setFormData(response);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        } else {
            setFormData(newEntity);
        }
    }

    useEffect(() => {
        makeQuery();
    }, [id]);

    function clearEntity() {
        setFormData(newEntity);
    }

    const onConfirm = async () => {

        try {
            if (validateInputs()) {
                setLoading(true);
                await new Promise(resolve => setTimeout(resolve, 300));
                await saveEntity();
                navigate('/app/sectorlist');
            }
        } catch (error) {
            console.error('Error saving:', error);
            showAlert('Error ao salvar.');
        } finally {
            setLoading(false);
        }
    };

    function validateInputs() {

        if (!formData.name || formData.name === '') {
            showAlert('Preencha o campo nome.');
            return false;
        }

        return true;
    }

    async function saveEntity() {
        const url = apiUrl + '/api/sectors';
        setLoading(true);
        await makeRequest(url, id ? 'PUT' : 'POST', {
            'Content-Type': 'application/json',
        }, JSON.stringify(formData));
        setLoading(false);
    }

    if (loadingPermissions) {
        return <Loading/>
    }

    if (hasUserPermission(UserPermission.CREATE_SECTOR) === false || (hasUserPermission(UserPermission.EDIT_SECTOR) === false && id)) {
        navigate('/unauthorizedaccess');
    }

    return (
        <div className="app-form-page app-form-page--narrow">
            <div className="header-label">{formData.id > 0 ? 'Editar' : 'Cadastrar'} Setor</div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Nome:</div>
                <input type="text" style={{width: '300px'}} value={formData.name} name="name"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Cor:</div>
                <input
                    type="color"
                    style={{width: '300px', height: '32px', padding: '0', border: "none"}}
                    value={formData.color}
                    name="color"
                    onChange={handleChange}
                />
            </div>


            <ActionButtonsManagerView>
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>


        </div>
    );
};

export default SectorManager;
